module.exports = __webpack_public_path__ + "static/media/test11_4.a2499284.png";